import { render, staticRenderFns } from "./comMsg.vue?vue&type=template&id=1b43f3e7&scoped=true&"
import script from "./comMsg.vue?vue&type=script&lang=js&"
export * from "./comMsg.vue?vue&type=script&lang=js&"
import style0 from "./comMsg.vue?vue&type=style&index=0&id=1b43f3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43f3e7",
  null
  
)

export default component.exports